export default __webpack_public_path__ + "static/media/trades-white.95da5085.svg";